import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from './../../types/entity';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface ITextTranslation extends IEntity {
  attributes: {
    id: EntityStringId;
    language: Language;
    translation: string;
  };
}

export type TextTranslation = Entity<ITextTranslation>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextTranslation: IEntityType<ITextTranslation> = vmClient.defineClass({
  typeName: 'TextTranslation',
  version: 1,
  lockable: true,
  persisted: true,

  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    translation: {
      type: 'string',
      notNull: true,
    },
  },
});
